// Sub-navigation entries for the Stocks workspace. Used by every Stocks sub-page.
export const STOCKS_TABS = [
  { to: '/stocks',            label: 'Overview',       end: true },
  { to: '/stocks/heatmap',    label: 'Heatmap' },
  { to: '/stocks/fear-greed', label: 'Fear & Greed' },
];
